/*! cart-bfcache-refresh.js — keeps mini cart in sync on browser back/forward and on drawer open */
(function () {
  function safeGetCart() {
    try {
      if (window.Shopify && typeof window.Shopify.getCart === 'function') {
        window.Shopify.getCart();
      } else if (window.ShopifyAPI && typeof window.ShopifyAPI.getCart === 'function') {
        window.ShopifyAPI.getCart();
      }
    } catch (e) { /* no-op */ }
  }

  // Refresh when the page is restored from bfcache (Safari/Firefox/Chrome)
  window.addEventListener('pageshow', function (event) {
    var navEntry;
    if (performance && performance.getEntriesByType) {
      var entries = performance.getEntriesByType('navigation');
      if (entries && entries[0]) { navEntry = entries[0]; }
    }
    var cameFromHistory = (navEntry && navEntry.type === 'back_forward') || event.persisted === true;
    if (cameFromHistory) { safeGetCart(); }
  }, true);

  // Also refresh right before opening the mini cart drawer
  document.addEventListener('click', function (e) {
    var el = e.target;
    // climb up to anchor if icon/svg inside
    while (el && el !== document) {
      if (el.matches && el.matches('a.ltn__utilize-toggle[href="#ltn__utilize-cart-menu"]')) {
        safeGetCart();
        break;
      }
      el = el.parentNode;
    }
  }, true);
})();